const TmpPE002 = (page) => {
  const modifiedPage = {
    ...page
  };

  // remove media from each core item, not used
  if (modifiedPage.content?.core) {
    modifiedPage.content.core = modifiedPage.content.core.map((item) => {
      const modifiedItem = { ...item };

      delete modifiedItem.media;

      return modifiedItem;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE002;
